import routerPaths from 'src/integration/config/routerPaths';
import { useNavigate } from 'react-router-dom';
import { useStore } from 'src/integration/store/store';

const useErrorHandling = () => {
  const { configStore } = useStore();
  const { removeJwtToken } = configStore;
  const navigate = useNavigate();

  const logoutOnError = () => {
    removeJwtToken();
    navigate(routerPaths.login());
  }

  return {
    logoutOnError
  }
}

export default useErrorHandling